import Reveal from "../components/ui/Reveal";
import { Link } from "react-router-dom";
import ServicePackages from "../components/ServicePackages";
import ProcessSection from "../components/ProcessSection";
import imgenhero from "../assets/a10.png";
import ScrollToTop from "../components/ui/ScrollToTop";
import LogoMarquee from "../components/home/LogoMarquee";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { services } from "../data/servicios"
import { FaWhatsapp } from "react-icons/fa";
import SEO from "../components/SEO";

const Services = () => {

  const heroRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"]
  });

  // movimiento parallax
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);

  return (
    <div className="pt-32">
      <SEO
        title="Servicios de Ingeniería Civil y Planos Arquitectónicos"
        description="Servicios profesionales de ingeniería civil, topografía, subdivisión, declaratoria de fábrica y planos arquitectónicos modernos."
        canonical="https://www.planixapp.com/servicios"
        keywords="servicios de ingeniería civil, planos arquitectónicos, topografía, subdivisión de terrenos, declaratoria de fábrica, formalización de predios, asesoría técnica construcción"
        image="https://www.planixapp.com/cover.jpg"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": "Ingeniería Civil y Planos Arquitectónicos",
          "provider": {
            "@type": "Organization",
            "name": "Planix",
            "url": "https://www.planixapp.com"
          }
        }}
      />

      {/* HERO PARALLAX */}
      <section
        ref={heroRef}
        className="relative w-full h-[420px] md:h-[520px] overflow-hidden"
      >

        {/* Imagen */}
        <motion.img
          src={imgenhero}
          alt="Servicios prediales"
          style={{ y }}
          className="absolute top-0 left-0 w-full h-[130%] object-cover"
        />

        {/* Overlay oscuro */}
        <div className="absolute inset-0 bg-black/40"></div>

        {/* Contenido */}
        <div className="relative flex flex-col justify-center items-center text-center h-full px-6">

          <Reveal>
            <h1 className="text-4xl md:text-5xl font-bold text-white">
              Regularización de{" "}
              <span className="text-[#F26B1D]">Predios</span>
            </h1>
          </Reveal>

          <Reveal>
            <p className="mt-6 text-gray-200 max-w-2xl">
              Servicios técnicos y legales para formalizar, subdividir y desarrollar tu propiedad con total seguridad.
            </p>
          </Reveal>

        </div>

      </section>

      <ScrollToTop />

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold">
            Soluciones técnicas para construcción y propiedad
          </h2>

          <p className="mt-6 text-gray-600 leading-relaxed">
            En Planix ofrecemos servicios de ingeniería civil,
            topografía, elaboración de planos arquitectónicos,
            subdivisión de terrenos y regularización de predios
            para clientes en Perú y otros países.
          </p>
        </div>
      </section>

      <ServicePackages />

      {/* SERVICIOS */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {services.map((group, index) => (
            <div key={index} className="mb-20">
              <Reveal>
                <h2 className="text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-10 flex items-center gap-3">
                  <span className="w-2 h-8 bg-[#F26B1D] rounded-full"></span>
                  {group.category}
                </h2>
              </Reveal>
              <div className="grid md:grid-cols-3 gap-8">
                {group.items.map((service, i) => (
                  <Reveal key={i} delay={i * 0.1} >
                    <motion.div
                      whileHover={{ y: -6 }}
                      className="p-8 border border-gray-100 rounded-2xl shadow-sm hover:shadow-lg transition bg-white"
                    >
                      <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-orange-50 text-[#F26B1D] mb-5 text-2xl transition group-hover:scale-110">
                        {service.icon}
                      </div>

                      <h3 className="text-xl font-semibold text-[#1C1C1C] group-hover:text-[#F26B1D] transition">
                        {service.title}
                      </h3>
                      <p className="mt-3 text-gray-600 leading-relaxed">
                        {service.description}
                      </p>
                      <Link to={`/servicios/${service.slug}`} className="block group">
                        <motion.div
                          whileHover={{ y: -8 }}
                        >
                          <span className="inline-block mt-6 text-[#F26B1D] font-semibold group-hover:underline">
                            Ver detalle →
                          </span>
                        </motion.div>
                      </Link>
                    </motion.div>
                  </Reveal>
                ))}

              </div>

            </div>
          ))}

        </div>
      </section>

      <ProcessSection />

      <LogoMarquee />

      {/* CTA */}
      <section className="relative z-20 px-6 py-16 md:py-24">
        <div className="max-w-5xl mx-auto bg-[#252525] rounded-3xl p-10 md:p-16 text-center shadow-2xl border border-gray-800 relative overflow-hidden">

          {/* Glow decorativo */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#F26B1D] opacity-10 blur-3xl" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#F26B1D] opacity-5 blur-3xl" />

          {/* Contenido */}
          <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight">
            ¿Necesitas asesoría para tu propiedad?
          </h2>

          <p className="mt-4 text-gray-400 max-w-xl mx-auto text-sm md:text-base">
            Te ayudamos a formalizar tu inmueble, optimizar tu inversión
            y avanzar con seguridad en cada etapa de tu proyecto.
          </p>

          {/* BOTÓN PRO */}
          <div className="mt-8 flex justify-center">
            <motion.a
              href={`https://wa.me/51983974833?text=${encodeURIComponent(
                "Hola, quiero asesoría sobre servicios prediales"
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="
          inline-flex items-center justify-center gap-3
          bg-[#F26B1D] hover:bg-[#d95a16]
          text-white
          px-6 py-3 md:px-10 md:py-4
          rounded-xl font-semibold md:font-bold
          text-sm md:text-base
          w-full sm:w-auto
          transition-all duration-300
          shadow-lg shadow-[#F26B1D]/20
          hover:shadow-xl hover:-translate-y-1
        "
            >
              <FaWhatsapp size={20} />
              <span className="whitespace-nowrap">
                Solicitar asesoría
              </span>
            </motion.a>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Services;